<div class="table">
    <div class="cards">
        <div class="first-card-wrapper">
            <div class="first-card card-{{ card }}" [class.placeholder]="!card"></div>
        </div>

        <div class="burned-cards">
            <div class="row">
                <div *ngFor="let i of [1, 2, 3, 4, 5]" class="card-back" [class.show]="i <= burnedCardsCount"></div>
            </div>
            <div class="row">
                <div *ngFor="let i of [6, 7, 8, 9, 10]" class="card-back" [class.show]="i <= burnedCardsCount"></div>
            </div>
        </div>
    </div>
</div>
